module.exports = __webpack_public_path__ + "img/Leste-Logo-Login.aa8149d3.svg";